import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#258750',
        secondary: '#676879',
        accent: '#80e3ba',
        error: '#d83a52',
      },
    },
  },
};

export default new Vuetify(opts);
